import { inject, Injectable } from '@angular/core';
import { StationDetail } from '@models/station/detail';
import {
    StationFilterOptions,
    StationFilterOptionsResponse,
} from '@models/station/filter-options';
import { SharedMapper } from '../shared.mapper';

@Injectable({
    providedIn: 'root',
})
export class StationMapper {
    private readonly sharedMapper = inject(SharedMapper);

    toStationDetail = (item: StationDetail) => {
        return new StationDetail(
            item.id,
            item?.name ?? '',
            item?.description ?? '-',
            item?.numberOfUsers ?? 0,
            item?.communicationType,
            item?.type,
            item?.location ?? '-',
            item?.status,
            item?.expirationReferenceDate ?? null,
        );
    };

    toStationDetailFilterOptions = (
        item: StationFilterOptionsResponse,
    ): StationFilterOptions =>
        new StationFilterOptions(
            item.maxNumberOfUsers ?? null,
            (item?.type || [])?.map(this.sharedMapper.toSelectOption) ?? [],
            (item?.communicationType || [])?.map(
                this.sharedMapper.toSelectOption,
            ) ?? [],
            (item?.status || [])?.map(this.sharedMapper.toSelectOption) ?? [],
        );
}
